// Persistance locale uniquement. Aucune donnée envoyée à un serveur.
const KEYS = {
  prefs: "softlanding.prefs.v1",
  favs: "softlanding.favorites.v1",
  hist: "softlanding.history.v1",
  space: "softlanding.space.v1",
  babyAck: "softlanding.baby.acknowledged.v1",
  profile: "softlanding.profile.v1",
  discoveryPrompted: "softlanding.discovery.prompted.v1",
  premiumWelcomeSeen: "softlanding.premium.welcome.v1",
};

function safeGet(k, fallback) {
  try {
    const raw = localStorage.getItem(k);
    return raw ? JSON.parse(raw) : fallback;
  } catch { return fallback; }
}
function safeSet(k, v) {
  try { localStorage.setItem(k, JSON.stringify(v)); } catch { /* ignore */ }
}

export const store = {
  getPrefs: () => safeGet(KEYS.prefs, { need: null, minutes: 5, preference: "combi", tts: false, preferRecorded: false }),
  setPrefs: (p) => safeSet(KEYS.prefs, p),

  getFavorites: () => safeGet(KEYS.favs, []),
  toggleFavorite: (id) => {
    const list = safeGet(KEYS.favs, []);
    const next = list.includes(id) ? list.filter(x => x !== id) : [...list, id];
    safeSet(KEYS.favs, next);
    return next;
  },

  getHistory: () => safeGet(KEYS.hist, []),
  addHistoryEntry: (entry) => {
    const list = safeGet(KEYS.hist, []);
    const at = new Date().toISOString();
    const next = [{ ...entry, at }, ...list].slice(0, 200);
    safeSet(KEYS.hist, next);
    return at;
  },
  updateHistoryEntry: (at, patch) => {
    const list = safeGet(KEYS.hist, []);
    const next = list.map(e => e.at === at ? { ...e, ...patch } : e);
    safeSet(KEYS.hist, next);
    return next;
  },

  getSpace: () => safeGet(KEYS.space, null),
  setSpace: (s) => safeSet(KEYS.space, s),

  hasBabyAck: () => safeGet(KEYS.babyAck, false),
  setBabyAck: (b) => safeSet(KEYS.babyAck, b),

  getProfile: () => safeGet(KEYS.profile, null),
  setProfile: (p) => safeSet(KEYS.profile, p),
  clearProfile: () => { try { localStorage.removeItem(KEYS.profile); } catch { /* ignore */ } },

  hasDiscoveryPrompt: () => safeGet(KEYS.discoveryPrompted, false),
  setDiscoveryPrompt: (v) => safeSet(KEYS.discoveryPrompted, v),

  hasSeenPremiumWelcome: () => safeGet(KEYS.premiumWelcomeSeen, false),
  setPremiumWelcomeSeen: (v) => safeSet(KEYS.premiumWelcomeSeen, v),

  clearAll: () => {
    Object.values(KEYS).forEach(k => { try { localStorage.removeItem(k); } catch { /* ignore */ } });
  },
};
